<!-- @Author Shyam @Date 11/03/2026 @Description: Workflow Pop-up Component -->
<div
  class="topdiv"
  style="margin-top: 30px; margin-right: 30px; padding: 3px"
  *ngIf="!showWorkflowForm"
>
  <div
    class="workflow-header d-flex justify-content-between align-items-center px-4 py-2"
  >
    <!-- LEFT: Breadcrumb -->
    <div class="breadcrumb-text">
      <span
        class="breadcrumb-link"
        style="font-size: 16px; font-weight: 500"
        (click)="backToWorkflowpage()"
      >
        Workflows
      </span>
      <span> > </span>
    </div>

    <!-- RIGHT: Buttons -->
    <div class="d-flex gap-2" style="gap: 10px">
      <app-common-button
        *ngIf="!isEditMode"
        label="Edit"
        title="Edit"
        [buttonId]="1111"
        width="110px"
        (clicked)="enableEdit()"
      ></app-common-button>
      <ng-container *ngIf="isEditMode">
        <app-common-button
          [label]="buttonName"
          [title]="buttonName"
          [critical]="true"
          [buttonId]="1111"
          width="110px"
          (clicked)="onSubmit()"
        ></app-common-button>

        <app-common-button
          label="Cancel"
          title="Cancel"
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          (clicked)="onCancel()"
        ></app-common-button>
      </ng-container>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="mt-4 ps-3 ps-md-0 mb-3">
    <form
      novalidate
      [formGroup]="validations_form"
      [ngClass]="{ 'view-mode': !isEditMode }"
    >
      <div class="row px-5" style="row-gap: 10px">
        <!-- Lifecycle -->
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Workflow Name</mat-label>
            <input
              matInput
              placeholder="Workflow Name"
              type="text"
              formControlName="workflowname"
              [(ngModel)]="workflowDto.workflowname"
              required
              [disabled]="!isEditMode"
            />
            <mat-error
              *ngFor="let validation of validation_messages.workflowname"
            >
              <span
                *ngIf="
                  validations_form
                    .get('workflowname')
                    .hasError(validation.type) &&
                  (validations_form.get('workflowname').dirty ||
                    validations_form.get('workflowname').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Description -->
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Description</mat-label>
            <input
              matInput
              type="text"
              placeholder="Description"
              formControlName="description"
              [(ngModel)]="workflowDto.description"
              [disabled]="!isEditMode"
            />
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Lifecycle</mat-label>
            <mat-select
              formControlName="lifecyclename"
              [(ngModel)]="workflowDto.lifecyclename"
              (selectionChange)="onLifecycleChange($event)"
              [disabled]="buttonName === 'Update' || !isEditMode"
            >
              <mat-option
                *ngFor="let lifecycle of lifecycleData"
                [value]="lifecycle.lifecycleid"
              >
                {{ lifecycle.lifecyclename }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngFor="let validation of validation_messages.lifecyclename"
            >
              <span
                *ngIf="
                  validations_form
                    .get('lifecyclename')
                    .hasError(validation.type) &&
                  (validations_form.get('lifecyclename').dirty ||
                    validations_form.get('lifecyclename').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">Start State</mat-label>
            <mat-select
              formControlName="startstates"
              (selectionChange)="onStartStateChange($event)"
              [(ngModel)]="workflowDto.startstates"
              [disabled]="buttonName === 'Update' || !isEditMode"
            >
              <mat-option *ngFor="let state of states" [value]="state.stateid">
                {{ state.statename }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngFor="let validation of validation_messages.startstates"
            >
              <span
                *ngIf="
                  validations_form
                    .get('startstates')
                    .hasError(validation.type) &&
                  (validations_form.get('startstates').dirty ||
                    validations_form.get('startstates').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@Targetstdcode">State Type</mat-label>
            <input
              matInput
              type="text"
              placeholder="State Type"
              formControlName="starttype"
              [(ngModel)]="workflowDto.starttype"
              readonly
            />
          </mat-form-field>
        </div>
      </div>
    </form>
    <!-- <div class="row mt-4 justify-content-end g-2 px-3">
      
      <app-common-button
        [label]="buttonName"
        [title]="buttonName"
        [critical]="true"
        [buttonId]="1111"
        width="110px"
        (clicked)="onSubmit()"
        style="margin-left: 6px; margin-right: 6px"
      >
      </app-common-button>
     
      <app-common-button
        label="Cancel"
        title="Cancel"
        [critical]="true"
        [buttonId]="1111"
        variant="cancel"
        width="110px"
        (clicked)="onCancel()"
        style="margin-left: 6px; margin-right: 6px"
      >
      </app-common-button>
     
    </div> -->
  </div>

  <div style="margin-bottom: 2em"></div>
  <div class="row mt-4">
    <div class="col-12 align-items-center">
      <div>
        <div>
          <mat-toolbar
            class="agGridtoperDiv card"
            style="
              background: rgb(228 227 230 / 41%);
              border-top: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;
              border-left: 1px solid #a9a9a9a8;
            "
          >
            <label i18n="@@spmsUserReg" class="textColour"
              >Workflow Steps Creation</label
            >

            <span class="example-spacer"></span>
            <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Configure Pivot" (click) = "openPivotConfigurationPopup()">Configure Visuals
                        </button> -->
            <app-common-button
              label="Add Record"
              title="Add Record"
              [critical]="true"
              [buttonId]="1111"
              width="110px"
              [disabled]="
                isEditMode && this.workflowDto.workflowid !== 'undefined'
              "
              (clicked)="openSaveForm('Save')"
              style="margin-left: 6px; margin-right: 6px"
            >
            </app-common-button>
            <div class="insertPageNoDiv">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                <input
                  matInput
                  type="text"
                  (input)="onSearchChange($event.target.value)"
                />
              </mat-form-field>
            </div>

            <div class="selectRecordsDiv" style="width: 9.5%">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label i18n="@@spmsUserRegrecords" style="color: black"
                  >Records</mat-label
                >
                <mat-select
                  [(ngModel)]="pagesize"
                  (ngModelChange)="onPageSizeChanged()"
                >
                  <mat-option value="5" selected>5</mat-option>
                  <mat-option value="10">10</mat-option>
                  <mat-option value="100">100</mat-option>
                  <mat-option value="200">200</mat-option>
                  <mat-option value="300">300</mat-option>
                  <mat-option value="400">400</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="card pagination paginationFirstButton paginationFirstlastButton"
            >
              <em
                class="fas fa-angle-double-left waves-effect waves-light"
                (click)="onBtFirst()"
              ></em>
            </div>
            <div class="card pagination paginationButtons btn-rounded">
              <ul>
                <li class="paginationliicon">
                  <em
                    class="fas fa-angle-left waves-effect waves-light"
                    (click)="onBtPrevious()"
                  ></em>
                </li>
                <li>{{ currentpage }}/{{ totalpages }}</li>
                <li class="paginationliicon" style="padding: 0">
                  <em
                    class="fas fa-angle-right waves-effect waves-light"
                    (click)="onBtNext()"
                  ></em>
                </li>
              </ul>
            </div>
            <div
              class="card pagination paginationLastButton paginationFirstlastButton"
            >
              <em
                class="fas fa-angle-double-right waves-effect waves-light"
                (click)="onBtLast()"
              ></em>
            </div>
          </mat-toolbar>
        </div>
        <ag-grid-angular
          class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="columnDefs"
          [animateRows]="true"
          [pagination]="true"
          [defaultColDef]="defaultColDef"
          [suppressPaginationPanel]="true"
          [rowHeight]="35"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true"
          [debug]="true"
          [rowClassRules]="rowClassRules"
          (paginationChanged)="onPaginationChanged()"
          [components]="components"
          (gridReady)="onGridReady($event)"
          [hidden]="!true"
          [rowData]="rowData"
          style="height: 30vh; margin-bottom: 3%"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
<app-work-flow-steps
  *ngIf="showWorkflowForm"
  [data]="selectedStepForEdit"
  [workflowName]="workflowDto.workflowname"
  [workflowId]="workflowDto.workflowid"
  [step]="workflowSteps"
  (goToWorkflowsEvent)="backToWorkflowpage()"
  (goToWorkflowPopupEvent)="handleBackToWorkflow()"
  (backToWorkFlow)="backToWorkflowpage()"
  (closeEvent)="closeWorkflowForm($event)"
></app-work-flow-steps>
